import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Link,
} from '@mui/material';
import Loader from '../../../common/Loader';

const CountryPrefixMaps = ({ country, prefixMaps, loading, navigate }) => {
  const showSinglePrefixMap = (prefixMap) => {
    navigate(
      `/admin/service-config/country/${country.country_code_id}/prefix-map/${prefixMap.country_prefix_map_id}`
    );
  };

  const showNew = () => {
    navigate(
      `/admin/service-config/country/${country.country_code_id}/prefix-map/0`
    );
  };

  if (loading) return <Loader />;

  if (prefixMaps.length === 0)
    return <Typography>No Prefix Maps Found.</Typography>;

  return (
    <Box key="PrefixMapList">
      <Box display="flex" justifyContent="space-between" marginBottom={1}>
        <Typography variant="h4">List of Prefix Maps</Typography>
        <Button variant="contained" color="secondary" onClick={showNew}>
          Add New
        </Button>
      </Box>

      <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
        <Table aria-label="prefix maps table">
          <TableHead>
            <TableRow>
              <TableCell>Before Prefix</TableCell>
              <TableCell>After Prefix</TableCell>
              <TableCell>Length</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {prefixMaps.map((prefixMap) => (
              <TableRow
                key={prefixMap.country_prefix_map_id}
                id={`prefix-map-${prefixMap.country_prefix_map_id}`}
              >
                <TableCell align="left">
                  <Link
                    tabIndex={0}
                    onClick={() => showSinglePrefixMap(prefixMap)}
                  >
                    {prefixMap.before_prefix}
                  </Link>
                </TableCell>
                <TableCell align="left">{prefixMap.after_prefix}</TableCell>
                <TableCell align="left">{prefixMap.tn_length}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CountryPrefixMaps;
